import { Injectable, inject } from '@angular/core';
import { AuthService } from '@dabnet-kamu/libs/auth';
import { SessionService } from '@dabnet-kamu/libs/auth/components/session.service';

@Injectable({ providedIn: 'root' })
export class GlobalAuthFetchService {

  private authService = inject(AuthService);
  private sessionService = inject(SessionService);

  // Aynı anda birden fazla kez init çağrılırsa ikinciyi yok say
  private initialized = false;
  private originalFetch: typeof window.fetch | null = null;

  init(): void {
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    this.originalFetch = window.fetch.bind(window);

    window.fetch = async (
      input: RequestInfo | URL,
      init?: RequestInit
    ): Promise<Response> => {
      const url = input.toString();
      const isDxxrdv = url.includes('DXXRDV');

      let user = this.authService.loggedUser;
      let token = user?.access_token;

      /* console.log('[AUTH_FETCH]', 'request', url);
      console.log('[AUTH_FETCH]', 'before', {
        hasUser: !!user,
        expiredFlag: user?.expired,
        expires_at: (user as any)?.expires_at,
        isExpired: this.authService.isAccessTokenExpired(user, 5)
      }); */

      // Token yoksa veya expire olmak üzereyse: önce silent renew dene,
      // sadece gerçekten başarısız olursa merkezi logout tetikle.
      if (!token || this.authService.isAccessTokenExpired(user, 5)) {
        //console.log('[AUTH_FETCH]', 'Token yok veya expired/expiring');
        try {
          user = await this.authService.ensureValidUser();
          token = user.access_token;
          //console.log('[AUTH_FETCH]', 'after ensureValidUser', {
           // hasUser: !!user,
            //expiredFlag: user?.expired,
            //expires_at: (user as any)?.expires_at,
           // isExpired: this.authService.isAccessTokenExpired(user, 5)
          //});
        } catch {
          //console.log('[AUTH_FETCH]', 'ensureValidUser FAILED, forceLogout');
          await this.sessionService.forceLogout();
          return Promise.reject(
            new Response(null, { status: 401, statusText: 'Token Expired' })
          );
        }
      }

      const headers = new Headers(init?.headers || {});

      // 🔹 DXXRDV (DevExpress Report) isteklerinde:
      // - Mevcut Content-Type / body formatına DOKUNMA
      // - Sadece Authorization header ekle
      //
      // Diğer tüm isteklerde:
      // - Content-Type yoksa application/json olarak ayarla
      if (!isDxxrdv && !headers.has('Content-Type')) {
        headers.set('Content-Type', 'application/json');
      }

      headers.set('Authorization', `Bearer ${token}`);

      const response = await this.originalFetch!(input, {
        ...init,
        headers
      });

      // 🔹 Bu seviyede artık geçerli token ile istek yapılmış kabul ediyoruz.
      // Backend'in 401/403 dönmesi durumunda global logout yapmak yerine
      // hatayı isteği yapan tarafa bırakıyoruz.
      return response;
    };
  }
}
